export enum ImpersonationDuration {
  OneDay = '1',
  FiveDays = '5',
  TenDays = '10',
  ThreeSixtyFiveDays = '365'
}

export enum SupportRequestStatus {
  Yes = 'Yes',
  No = 'No'
}

export enum AccessScopes {
  CapitalAccess = 'Capital Access'
}
